import React from 'react';

const SectionHeader = ({ title, isVisible, onClick }) => {
  return (
    <div className="section-header" onClick={onClick}>
      <h4>{title}</h4>
      <span className="dropdown-arrow">
        {isVisible ? '▼' : '▶'}
      </span>
    </div>
  );
};

export default SectionHeader;